module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHRpdGxlPnRpY2s8L3RpdGxlPjxwYXRoIGQ9Ik0xNywyOUExMiwxMiwwLDEsMSwyNS4xLDguMTZMMTYuMzgsMTguNTksMTEsMTQuODEsOCwxOC4zMmw4LjgxLDYuNzUsMTEtMTMuMTUsMi43Ni0zLjI5QTE2LDE2LDAsMSwwLDMzLDE3SDI5QTExLjc4LDExLjc4LDAsMCwxLDE3LDI5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMS4wMSAtMSkiIHN0eWxlPSJmaWxsOiMwMDAxMDAiLz48cGF0aCBkPSJNMjcuODgsMTJsMi43Ni0zLjN2MGwtMi43NiwzLjI5djAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xLjAxIC0xKSIgc3R5bGU9ImZpbGw6I2ZmZiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/tick.svg
// module id = NeOv
// module chunks = 1